import { elements } from './elements.js';
import {
    bindClearAllButton,
    bindFormFields,
    bindFormSubmission,
    resetAndFetchResults
} from '../shared/singleSectionSearch.js';
import { initializeExpandableFilter } from '../../../includes/collapseFilterGroup.js';
import { hiddenClass } from '../../../config.js';

export const bindFormElements = (fetchResults, updateQueryString, allChoices) => {
    const {
        searchForm,
        publishedAfterInput,
        publishedBeforeInput,
        newsTypeSelect,
        expandFilterButton,
        expandableFilter,
        clearAllButton,
        clearDateButtons
    } = elements;

    if (
        !searchForm ||
        !publishedAfterInput ||
        !publishedBeforeInput ||
        !newsTypeSelect ||
        !expandFilterButton ||
        !expandableFilter ||
        !clearAllButton
    ) return;

    // Bind other form fields for updates
    bindFormFields(
        [newsTypeSelect],
        () => resetAndFetchResults(fetchResults, updateQueryString, searchForm)
    );

    // Bind form submission for manual search
    bindFormSubmission(
        searchForm,
        () => resetAndFetchResults(fetchResults, updateQueryString, searchForm)
    );

    initializeExpandableFilter(expandFilterButton, expandableFilter);

    bindClearAllButton(clearAllButton, searchForm, () => {
        publishedAfterInput.value = '';
        publishedBeforeInput.value = '';
        Object.values(allChoices).forEach(choice => choice.setChoiceByValue(''));
        clearDateButtons.forEach(clearDateButton => clearDateButton.classList.add(hiddenClass));
        resetAndFetchResults(fetchResults, updateQueryString, searchForm);
    });
};
